import React, { useRef, useState } from "react";
import * as Text from "@/components/text";
import Flicking from "@egjs/react-flicking";
import "@egjs/react-flicking/dist/flicking.css";
import AnchorChip from "@/components/lib/AnchorChip";
import Image from "next/image";
import Button from "@/components/actions/Button";
import Link from "next/link";
import ReactMarkdown from "react-markdown";
import { localeTexts } from "@/utils/locale";

export default function Magazine({ data, locale }) {
  const flickingRef = useRef(null);
  const [indexFlicking, setIndexFlicking] = useState(0);
  const handleChangeIndex = (index) => {
    setIndexFlicking(index);
    flickingRef.current.forceUpdate();
  };

  return (
    <div className="lg:amb-container py-8 lg:w-fit">
      <div className="mb-2 w-full text-center">
        <Text.Headline className="text-2xl font-light lg:text-[40px]">
          {localeTexts[locale].AmbulanteEdiciones.Magazine.title}
        </Text.Headline>
      </div>
      <Flicking
        ref={flickingRef}
        moveType="freeScroll"
        className="py-2 md:px-8 md:py-0 md:pb-4 md:pt-4"
        align="prev"
        viewportTag="div"
        cameraTag="div"
      >
        {data?.map((magazine, i) => (
          <div
            key={i}
            className="px-0.5 lg:flex lg:items-center lg:justify-center"
            onClick={() => {
              setIndexFlicking(i);
              handleChangeIndex(i);
            }}
          >
            <AnchorChip active={indexFlicking === i}>
              {magazine?.attributes?.title} (
              {new Date(magazine?.attributes?.publication_date).getFullYear()})
            </AnchorChip>
          </div>
        ))}
      </Flicking>
      <div className="md:flex md:items-start md:justify-start md:px-8">
        <div className="mt-4 flex w-full items-center justify-center md:mr-5 md:w-[596px]">
          <Image
            width={1208}
            height={633}
            className="h-[259px] w-[184px] object-cover md:h-[360px] md:w-[256px] lg:h-[533px] lg:w-[381px]"
            alt="Generation image"
            src={
              data?.[indexFlicking]?.attributes?.images?.data[0]?.attributes
                ?.url
            }
          />
        </div>
        <div>
          <div className="mt-3 flex w-full items-center justify-center md:mb-5 md:items-start md:justify-normal lg:mb-8">
            <Text.Headline className="lg:lg:text-4xl">
              {data?.[indexFlicking]?.attributes?.title} (
              {new Date(
                data?.[indexFlicking]?.attributes?.publication_date
              ).getFullYear()}
              )
            </Text.Headline>
          </div>
          <div className="mt-3 px-8 text-center  md:px-0 md:text-left">
            <ReactMarkdown className="prose text-[18px] font-light leading-[26px] prose-h2:uppercase md:text-[20px] lg:max-w-[100ch] lg:text-[22px]">
              {data?.[indexFlicking]?.attributes?.synopsis.replace(
                /<br>/g,
                "&nbsp; \n"
              )}
            </ReactMarkdown>
          </div>
          <div className="w-full px-4 md:w-[280px] md:px-0">
            <Link
              passHref
              target="_blank"
              href={data?.[indexFlicking]?.attributes?.download_link || ""}
            >
              <Button
                color="secondary-light"
                size="lg"
                className=" w-full sm:mt-5 lg:mr-6 lg:mt-10"
                trailingIcon={
                  <Image
                    width={100}
                    height={100}
                    src="/next_assets/icons/download_icon.svg"
                    alt="download icon"
                  ></Image>
                }
                label={localeTexts[locale].AmbulanteEdiciones.Magazine.download}
              ></Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
